module.exports = __webpack_public_path__ + "img/img_grade18.540b59bd.jpg";